import { Dispatch, IAppState } from 'shared/common/state';
import { ESortValue, jq } from 'shared/json_query';
import { fetchSearchMeta } from 'shared/services/fetchSearchMeta';
import { IApplicationContext } from 'shared/types/applicationContext';

import { getTermValue } from '../../../packages/JsonQuery';
import { makeSearch } from '../search';

export function changeSort(nextSort: ESortValue) {
  return async (dispatch: Dispatch, getState: () => IAppState, context: IApplicationContext) => {
    const {
      results: { jsonQuery },
      currentLocation,
    } = getState();

    const sort = getTermValue('sort')(jsonQuery);

    if ((!sort && nextSort === ESortValue.Default) || sort === nextSort) {
      return;
    }

    const modifiedJsonQuery = jq(jsonQuery).setSort(nextSort);

    const searchMeta = await fetchSearchMeta(context, {
      jsonQuery: modifiedJsonQuery,
    });

    dispatch(
      makeSearch({
        jsonQuery: modifiedJsonQuery,
        location: currentLocation,
        searchMeta,
      }),
    );
  };
}
